export default "<app-public-nav [@simpleFadeAnimation]=\"'in'\"></app-public-nav>\r\n<router-outlet></router-outlet>\r\n<app-public-footer></app-public-footer>"